const orgKey = 'orgTree'
export const setOrgTree = (org: string) => sessionStorage.setItem(orgKey, JSON.stringify(org))
export const getOrgTree = ():string => sessionStorage.getItem(orgKey) || '{}'

// User：用 localStorage，避免手机二次打开 sessionStorage 被清导致 agentId 丢失、菜单权限失效
const userKey = 'USER_INFO'
export const setUserInfo = (userInfo) => localStorage.setItem(userKey, JSON.stringify(userInfo))
export const getUserInfo = ():string => localStorage.getItem(userKey) || sessionStorage.getItem(userKey) || '{}'
export const removeUserInfo = () => {
  localStorage.removeItem(userKey)
  sessionStorage.removeItem(userKey)
}
